import type {
  EcommerceDashboardFilters,
  EcommerceDashboardTimeSeriesFilters,
} from '@/modules/flokee/interfaces/ecommerceDashboard.interface';

export const buildEcommerceDashboardParams = (
  filters?: EcommerceDashboardFilters | EcommerceDashboardTimeSeriesFilters,
) => {
  if (!filters) return {};

  const { range, start_date, end_date, group_by, assigned_campaign, assigned_source, metrics } =
    filters as EcommerceDashboardTimeSeriesFilters;

  return {
    range,
    start_date,
    end_date,
    group_by,
    assigned_campaign,
    assigned_source,
    'metrics[]': metrics,
  };
};
